module.exports = __webpack_public_path__ + "static/img/new-1.3eca7de9.png";